<template>
  <div class="allied">
    <div class="image-allied">
      <img :src="info.image" alt="Allied Image" />
    </div>

    <div class="content-allied">
      <div class="head-allied">
        <div class="titles-allied">
          <h2>{{info.name}}</h2>
          <p>{{info.position}}</p>
          <p>{{info.specialization}}</p>
        </div>
        <div class="logo-allied" v-if="info.brand">
          <img :src="info.brand" alt="Allied Logo" />
        </div>
      </div>
      <div class="body-allied">
        <p>
          <slot></slot>
        </p>
      </div>
      <div class="foot-allied">
        <a :href="info.mail | mailTo" target="_blank" class="contact">
          <font-awesome-icon :icon="['fas', 'envelope']"></font-awesome-icon>
        </a>
        <a :href="info.linkedin" target="_blank" class="contact">
          <font-awesome-icon :icon="['fab', 'linkedin-in']"></font-awesome-icon>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'CardAllied',
  components: {
    FontAwesomeIcon,
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  filters: {
    mailTo(mail) {
      return `mailto:${mail}`;
    },
  },
};
</script>

<style lang="scss" scoped>
div.allied {
  display: flex;
  width: 80%;
  margin: 20px auto;
  box-shadow: 0 0 50px -10px #666;
  border-radius: 3px;

  div.image-allied {
    width: 25%;

    img {
      width: 100%;
      margin-bottom: -4px;
      border-radius: 3px 0 0 3px;
    }
  }

  div.content-allied {
    width: calc(75% - 80px);
    overflow: hidden;
    padding: 20px 40px;
    position: relative;

    div.head-allied {
      display: flex;
      width: 100%;

      div.titles-allied {
        width: 70%;
        text-align: justify;

        h2 {
          margin: 0;
          padding: 0;
          font-family: Georgia, "Times New Roman", Times, serif;
          font-weight: normal;
        }

        p {
          margin: 0;
          padding: 5px 0;
          font-family: "Lucida Grande", Tahoma;
          font-size: 0.8em;
          text-transform: uppercase;
          letter-spacing: 0.1em;
        }
      }

      div.logo-allied {
        width: 30%;
        position: relative;

        img {
          position: absolute;
          width: 50%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    div.body-allied {
      padding: 20px 0;
      text-align: justify;

      p {
        margin: 0;
        padding: 0;
        font-family: Georgia, "Times New Roman", Times, serif;
        font-weight: normal;
        font-size: 18px;
        line-height: 1.5em;
      }
    }

    div.foot-allied {
      float: right;

      a.contact {
        margin: 0 10px;
        text-decoration: none;
        color: #76665b;
        font-size: 1.5em;
      }
    }
  }
}
</style>
